import {
    EMPTY_ARCHIVE_STATE_FILTER,
    EMPTY_ATTRIBUTES_BLANK_FILTER,
    EMPTY_CONSTRUCTOR_FILTER,
    EMPTY_CUSTOMER_FILTER,
    EMPTY_CUSTOMER_NUMBER_FILTER,
    EMPTY_HEADER_FILTER,
    EMPTY_MODEL_FILTER,
    EMPTY_ORDER_NUMBER_FILTER,
    EMPTY_TECHNOLOGIST_FILTER
} from "../OrderStatus";
import {matchEmptyOrIncludes} from "../../utils/common/matchEmptyOrIncludes";

export const ArchiveTableFilterData = [
    {
        "idFromColumnFilter": "number",
        "id": "number",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_ORDER_NUMBER_FILTER, options)
    },
    {
        "idFromColumnFilter": "customerOrder",
        "id": "customerOrder", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CUSTOMER_FILTER, options)
    },
    {
        "idFromColumnFilter": "header",
        "id": "header", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_HEADER_FILTER, options)
    },
    {
        "idFromColumnFilter": "model",
        "id": "modelOrder", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_MODEL_FILTER, options)
    },
    {
        "idFromColumnFilter": "constructor",
        "id": "constructor", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CONSTRUCTOR_FILTER, options)
    },
    {
        "idFromColumnFilter": "technologist",
        "id": "technologist", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_TECHNOLOGIST_FILTER, options)
    },
    {
        "idFromColumnFilter": "numberCustomer",
        "id": "numberCustomer",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CUSTOMER_NUMBER_FILTER, options)
    },
    {
        "idFromColumnFilter": "state",
        "id": "state",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_ARCHIVE_STATE_FILTER, options)
    },
    {
        "idFromColumnFilter": "year",
        "id": "year",
    },
    {
        "idFromColumnFilter": "dateOfConstructorDocumentation",
        "id": "dateOfConstructorDocumentation",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "dateOfReceipt",
        "id": "dateOfReceipt",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "dateOfTechnicalDocumentation",
        "id": "dateOfTechnicalDocumentation",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "shipped",
        "id": "shipped",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "manufactured",
        "id": "manufactured",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "attributes",
        "id": "attributes",
        "filterFn": (value, filterValue) => {
            if (filterValue === EMPTY_ATTRIBUTES_BLANK_FILTER) {
                return !value || value.length === 0
            }
            return value?.some((el) => el.name?.toLowerCase().includes(String(filterValue).toLowerCase()))
        }
    }
]
